// Theme customization options and presets

export const FONT_OPTIONS = [
  {
    id: 'classic',
    name: 'Classic Elegance',
    description: 'Playfair Display + Montserrat (Current)',
    headingFont: "'Playfair Display', serif",
    bodyFont: "'Montserrat', sans-serif",
    preview: 'Timeless Style'
  },
  {
    id: 'modern',
    name: 'Modern Luxury',
    description: 'Cormorant Garamond + Lato',
    headingFont: "'Cormorant Garamond', serif",
    bodyFont: "'Lato', sans-serif",
    preview: 'Contemporary Class'
  },
  {
    id: 'bold',
    name: 'Bold & Strong',
    description: 'Abril Fatface + Open Sans',
    headingFont: "'Abril Fatface', serif",
    bodyFont: "'Open Sans', sans-serif",
    preview: 'Make a Statement'
  },
  {
    id: 'minimal',
    name: 'Clean Minimal',
    description: 'Inter + Inter',
    headingFont: "'Inter', sans-serif",
    bodyFont: "'Inter', sans-serif",
    preview: 'Simple Excellence'
  }
];

export const COLOR_SCHEMES = [
  {
    id: 'navy-burgundy',
    name: 'Navy & Burgundy',
    description: 'Classic elegance (Current)',
    colors: {
      primary: '#001B2A',      // Navy
      secondary: '#7B1E2B',    // Burgundy
      accent: '#E6D7B3',       // Champagne
      neutral: '#2F2F2F',      // Charcoal
      light: '#FFFFFF'
    }
  },
  {
    id: 'charcoal-gold',
    name: 'Charcoal & Gold',
    description: 'Modern sophistication',
    colors: {
      primary: '#2C2C2C',      // Charcoal
      secondary: '#D4AF37',    // Gold
      accent: '#F5F5DC',       // Beige
      neutral: '#4A4A4A',      // Gray
      light: '#FFFFFF'
    }
  },
  {
    id: 'black-silver',
    name: 'Black & Silver',
    description: 'Timeless luxury',
    colors: {
      primary: '#000000',      // Black
      secondary: '#C0C0C0',    // Silver
      accent: '#E8E8E8',       // Light Gray
      neutral: '#1A1A1A',      // Dark Gray
      light: '#FFFFFF'
    }
  },
  {
    id: 'forest-tan',
    name: 'Forest & Tan',
    description: 'Natural elegance',
    colors: {
      primary: '#2C5F2D',      // Forest Green
      secondary: '#C19A6B',    // Tan
      accent: '#F4E4C1',       // Cream
      neutral: '#4A4A3A',      // Olive Gray
      light: '#FFFFFF'
    }
  }
];

export const LAYOUT_OPTIONS = [
  {
    id: 'default',
    name: 'Full Hero Layout',
    description: 'Large hero image with overlay (Current)',
    preview: 'Classic full-screen hero with content overlay'
  },
  {
    id: 'split',
    name: 'Split Screen',
    description: 'Content on left, image on right',
    preview: 'Modern split layout with balanced composition'
  },
  {
    id: 'centered',
    name: 'Centered Content',
    description: 'Centered text with background',
    preview: 'Minimal centered approach with focus on typography'
  },
  {
    id: 'carousel',
    name: 'Image Carousel',
    description: 'Rotating hero images',
    preview: 'Dynamic carousel showcasing multiple products'
  }
];
